import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        return (
            <div className="kts-platform-agreement">
                <h1>隐私政策</h1>
                <p>本公司（以下亦称“<span className="agreement-blod">天宏迅联</span>”、“我们”）深知隐私对您的重要性，并会尊重您的隐私。请您在开始使用本网站前仔细阅读隐私政策。您对本网站的使用即表明您接受本隐私政策，且您同意遵守其规定。</p>
                <h2>一、适用范围</h2>
                <p><span className="agreement-blod">1.1</span> 本隐私政策中的“信息”特指第二条所收集的信息，不适用于您存储在天宏FA TMGP平台（系统）中的数据。您可通过 《天宏迅联网站服务协议》知悉更多关于您存储在天宏FA TMGP平台中的数据的相关政策。</p>
                <h2>二、信息收集范围</h2>
                <p><span className="agreement-blod">2.1</span> 在注册、管理本网站账户，或进行实名认证的过程中，您需要提交真实、合法、有效的信息，包括但不限于名称、联系人、电子邮箱、联系电话、联系地址、银行账户信息、工商登记信息等。</p>
                <p><span className="agreement-blod">2.2</span> 在使用本服务的过程中，我们将记录并保存您登录和使用本服务的信息，包括但不限于 IP 地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据。</p>
                <h2>三、如何收集信息</h2>
                <p><span className="agreement-blod">3.1</span> 除您主动提交外，我们可能通过 <span className="agreement-blod">Cookies</span> 和其他相关技术收集和使用您的信息。<span className="agreement-blod">Cookie</span>文件保存在您的浏览器或电脑硬盘中。<span className="agreement-blod">Cookies</span>使用广泛，目的是为了让网站能正常或更高效地运行，以及向网站所有人提供信息。我们使用的<span className="agreement-blod">cookies</span>对于本网站至关重要。我们使用 <span className="agreement-blod">Cookies</span> 的具体用途包括：</p>
                <p><span className="agreement-blod">3.1.1</span> 估测我们的用户数量和使用模式；</p>
                <p><span className="agreement-blod">3.1.2</span> 记住您的身份。例如：<span className="agreement-blod">Cookies</span> 有助于我们辨认您作为我们的注册用户的身份； 3.1.3保存您的偏好信息，这样我们就可以定制我们的网站，并向您提供针对您个人兴趣的信息；</p>
                <p><span className="agreement-blod">3.1.4</span> 通过启用您的浏览器上的相关设置，您可以禁用<span className="agreement-blod">cookies</span>（可以禁用全部或部分<span className="agreement-blod">cookies</span>）。但是，当您通过对浏览器的设置来禁用所有<span className="agreement-blod">cookies</span>（包括最基本的<span className="agreement-blod">cookies</span>）时，您可能无法访问本网站的全部或部分内容；</p>
                <h2>四、信息使用</h2>
                <p><span className="agreement-blod">4.1</span> 我们出于如下目的，使用您提交以及我们收集的用户信息：</p>
                <p><span className="agreement-blod">4.1.1</span> 向您提供服务，向您推广、介绍产品。我们可不时通过电子邮件的方式向您发送资讯、和销售信息。您可以通过点击相关邮件中的“取消订阅”，轻松设置为不再接收此类邮件。</p>
                <p><span className="agreement-blod">4.1.2</span> 为了维护、改进服务。</p>
                <p><span className="agreement-blod">4.1.3</span> 满足您的个性化需求。例如，个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应。</p>
                <p><span className="agreement-blod">4.1.4</span> 提高您使用我们及我们关联公司、合作伙伴提供的服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或我们网站相关协议、规则的情况。</p>
                <p><span className="agreement-blod">4.1.5</span> 向您提供与您更加相关的服务。例如，向您提供您可能更感兴趣的广告等。</p>
                <p><span className="agreement-blod">4.1.6</span> 其他可能需要使用收集的信息的场景。</p>
                <h2>五、信息存储</h2>
                <p><span className="agreement-blod">5.1</span> 您提供给我们的所有信息均保存在我们的安全服务器上。 </p>
                <p><span className="agreement-blod">5.2</span> 我们保留您的信息的时间不会长于满足收集有关信息目的所必须的时间。但在下列情况下，我们有可能需要较长时间保留您的信息：</p>
                <p>（1）依照法律法规的规定、司法机关或行政机关的要求。<br/>
                    (2）为执行相关服务协议或本隐私政策、维护社会公共利益、处理投诉/纠纷，保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。
                </p>
                <h2>六、信息披露</h2>
                <p><span className="agreement-blod">6.1</span> 未经您同意，我们不会与任何无关第三方分享您的信息。</p>
                <p><span className="agreement-blod">6.2</span> 随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的信息有可能作为此类交易的一部分而被转移。我们将遵守相关法律法规的要求，在转移前通知您，并确保信息在转移时的机密性。</p>
                <p><span className="agreement-blod">6.3</span> 我们可能因以下原因而披露您的信息：</p>
                <p><span className="agreement-blod">6.3.1</span> 依照法律法规的规定、司法机关或行政机关的要求。 6.3.2为执行相关服务协议或本隐私政策、维护社会公共利益、处理投诉/纠纷，保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。</p>
                <p><span className="agreement-blod">6.3.3</span> 您授权披露的情形。
                如我们因上述原因而披露您的信息，我们将在遵守法律法规相关规定及本声明的基础上及时告知您。</p>
                <h2>七、信息安全</h2>
                <p><span className="agreement-blod">7.1</span> 我们努力采取各种合理的安全措施来保护您的用户信息。以防信息的丢失、不当使用、未经授权阅览或披露。</p>
                <p><span className="agreement-blod">7.2</span> 我们使用各种安全技术以保障信息的安全。例如，我们将通过服务器多备份、密码加密等安全措施，防止信息泄露、毁损、丢失。 7.3我们建立严格的管理制度和流程以保障信息的安全。例如，我们严格限制访问信息的人员范围，并进行审计，要求他们遵守保密义务。</p>
                <p><span className="agreement-blod">7.4</span> 由于技术的限制以及可能存在的各种恶意手段，在互联网环境下，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</p>
                <p><span className="agreement-blod">7.5</span> 请使用复杂密码，并妥善保管您的密码，同时加强自我保护意识。我们仅在我方直接导致您个人信息泄露的范围内承担责任。</p>
                <p><span className="agreement-blod">7.6</span> 若不幸发生用户信息安全事件，我们将按照法律法规的规定，及时告知您安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知用户信息主体时，我们会采取合理、有效的方式发布公告。</p>
                <h2>八、信息访问</h2>
                <p><span className="agreement-blod">8.1</span> 您可以在使用我们服务的过程中，访问、修改和删除您的相关信息。您访问、修改和删除信息的方式将取决于您使用的具体服务。基于法律法规要求或者信息安全保护等合理理由，部分信息可能无法访问、修改和删除，您应予以理解和接受。</p>
                <h2>九、隐私政策的更新</h2>
                <p><span className="agreement-blod">9.1</span> 我们可能适时修订本隐私声明的条款，该等修订构成本《隐私政策》的一部分。如可能造成您在本隐私声明下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本隐私声明的约束。</p>
                <h2>十、与我们联系</h2>
                <p><span className="agreement-blod">10.1</span> 如您对本政策内容有任何疑问和意见，请将您的问题发送至<a href="mailto: support@kingxunlian.com">support@kingxunlian.com</a> 或客服电话（<span className="agreement-blod">4008363566</span>）与我们联系。我们将尽快审核所涉问题，并在验证您的用户身份后的三十天内予以回复。</p>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/PrivacyAgreement/UI.Components.tsx